import Rover from '@rover/globals/Rover';
import alooma from '@rover/globals/alooma';
import { appendUrlParams, getUrlParameter } from './url';
import { getCookie } from './cookie';
import inject from './injector';

export const getRouteURL = (deeplink = 'rover://campaign/') => {
  const shouldIncludeMobileNativePushParam = inject(
    'Rover.context.shouldIncludeMobileNativePushParam',
    false
  );

  let deepLinkWithParams = deeplink; // eslint-disable-line

  if (Rover.deeplink) {
    deepLinkWithParams = Rover.deeplink;
  }

  // append Mobile Native Push UTM Params
  if (shouldIncludeMobileNativePushParam) {
    Rover.UTMParameters = {
      utm_source: 'app_install_banner',
      utm_medium: 'web',
      utm_campaign: 'quick_match_landing_20180102',
    };
  }

  // append utm parameters if they exist
  if (Rover.UTMParameters) {
    deepLinkWithParams = appendUrlParams(deepLinkWithParams, Rover.UTMParameters);
  }

  if (Rover.firstHttpReferrer) {
    deepLinkWithParams = appendUrlParams(deepLinkWithParams, {
      http_referrer: encodeURIComponent(Rover.firstHttpReferrer),
    });
  }

  // append Ambassador params if they exist
  const ambassadorMbsyCode = getUrlParameter('mbsy');
  if (ambassadorMbsyCode) {
    const extraAmbassadorParams = {
      mbsy: ambassadorMbsyCode,
      campaignid: getUrlParameter('campaignid') || '',
    };
    ['promo_code', 'utm_source', 'utm_content'].map(name => {
      const value = getUrlParameter(name);
      if (value) {
        extraAmbassadorParams[name] = value;
      }
    });
    deepLinkWithParams = appendUrlParams(deepLinkWithParams, extraAmbassadorParams);
  }

  // append rover_cid
  const roverCid = getCookie('rover_cid');
  if (roverCid) {
    deepLinkWithParams = appendUrlParams(deepLinkWithParams, { rover_cid: roverCid });
  }

  // Append alooma distinct_id to branch
  const aloomaCookie = getCookie('mp_rover_alooma');
  if (aloomaCookie) {
    const aloomaDistinctId = JSON.parse(decodeURIComponent(`${aloomaCookie}`)).distinct_id;
    if (aloomaDistinctId) {
      deepLinkWithParams = appendUrlParams(deepLinkWithParams, { distinct_id: aloomaDistinctId });
    }
  }

  // Deeplink needs the protocol removed
  const afterClickUrl = encodeURIComponent(window.location.href);
  const deeplinkPath = encodeURIComponent(deepLinkWithParams.split('rover://')[1]);
  const routeURL = appendUrlParams(`https://r.rover.com/a/${Rover.context.branchKey}`, {
    $deeplink_path: deeplinkPath,
    $after_click_url: afterClickUrl,
  });

  return routeURL;
};



// WEBPACK FOOTER //
// ../utilities/deeplink.js